import { jsx as _jsx } from "react/jsx-runtime";
const Square = ({ value, onClick }) => {
    return (_jsx("button", { className: "size-32 bg-gray-200 flex items-center justify-center rounded-md text-3xl font-bold text-gray-800 hover:bg-gray-300 focus:outline-none transition-colors duration-200", onClick: onClick, children: value }));
};
export default Square;
